import Messenger from '@/components/general/messenger/messenger'
import DataValidator from '@/components/general/data-validator/data-validator'

export default {
	name : 'app',
	components : {
		Messenger,
		DataValidator
	}
}


// WEBPACK FOOTER //
// ./src/app/script.js